module.exports = "<div>{{ 'account.unsub-notification-1' | translate }}</div>\n<br />\n<div>{{ 'account.unsub-notification-2' | translate }}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/feedback/unsub-notifications/unsub-notifications.component.html
// module id = 503
// module chunks = 0